import { isNumber, isString, raiseUnreachable } from '@weft/utils';
import type { To, NavigateOptions, NavigateFunction, Location } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import type { PathChangeStatus } from './use-vy-navigate-types';
import { PATH_CHANGE_STATUS } from './use-vy-navigate-types';

export const useVyNavigate = (): NavigateFunction => {
  const navigate = useNavigate();
  const location = useLocation();

  return (to: To | number, options: NavigateOptions = {}) => {
    return isNumber(to)
      ? navigate(to)
      : handleParamsNavigation(location, to, navigate, options);
  };
};

function getPathComparisonStatus(
  location: Location,
  to: To,
): PathChangeStatus {
  const toPathname = isString(to) ? to : to.pathname;
  const toSearch = isString(to) ? '' : to.search;

  if (toPathname === location.pathname && toSearch === location.search) {
    return PATH_CHANGE_STATUS.NONE;
  }

  if (toPathname === location.pathname) {
    return PATH_CHANGE_STATUS.PARAMS;
  }

  return PATH_CHANGE_STATUS.FULL;
}

function handleParamsNavigation(location: Location, to: To, navigate: NavigateFunction, options: NavigateOptions) {
  const comparisonResult = getPathComparisonStatus(location, to);

  switch (comparisonResult) {
    case PATH_CHANGE_STATUS.NONE:
      return undefined;
    case PATH_CHANGE_STATUS.PARAMS:
      return navigate(to, { ...options, replace: true });
    case PATH_CHANGE_STATUS.FULL:
      return navigate(to, options);
    default:
      return raiseUnreachable(comparisonResult);
  }
}